export default {
  mutations: {
    AUTHORIZE: 'AUTHORIZE',
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    AUTH_ERROR: 'AUTH_ERROR',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    AUTH_PERMISSIONS: 'AUTH_PERMISSIONS',
    SET_AUTH_USER: 'SET_AUTH_USER',
    SET_COMPANY_CONFIGURATION: 'SET_COMPANY_CONFIGURATION',
    SET_COMPANY: 'SET_COMPANY',
    SET_MENU: 'SET_MENU',
    SET_COMMPIX_CREDENTIALS: 'SET_COMMPIX_CREDENTIALS',
    SET_MASSPAYMENT_CREDENTIALS: 'SET_MASSPAYMENT_CREDENTIALS',
    SET_MANTECA_CREDENTIALS: 'SET_MANTECA_CREDENTIALS',
    SET_PVS_CREDENTIALS: 'SET_PVS_CREDENTIALS',
    SET_COMMPIX_CREDENTIALS_LIST: 'SET_COMMPIX_CREDENTIALS_LIST',
    SET_COMMPIX_AUTH_TOKEN: 'SET_COMMPIX_AUTH_TOKEN',
  },
  getters: {
    GET_MENU: 'GET_MENU',
    IS_AUTHENTICATED: 'IS_AUTHENTICATED',
    AUTH_STATUS: 'AUTH_STATUS',
    AUTH_PERMISSIONS: 'AUTH_PERMISSIONS',
    GET_AUTH_USER: 'GET_AUTH_USER',
    PERMISSIONS: 'PERMISSIONS',
    GET_COMPANY: 'GET_COMPANY',
    GET_USER_SESSION: 'GET_USER_SESSION',
    GET_COMMPIX_CREDENTIALS: 'GET_COMMPIX_CREDENTIALS',
    GET_MASSPAYMENT_CREDENTIALS: 'GET_MASSPAYMENT_CREDENTIALS',
    GET_COMMPIX_PRIMARY: 'GET_COMMPIX_PRIMARY',
    GET_MASSPAYMENT_PRIMARY: 'GET_MASSPAYMENT_PRIMARY',
    GET_MANTECA_CREDENTIALS: 'GET_MANTECA_CREDENTIALS',
    GET_NEMI_API_TOKEN: 'GET_NEMI_API_TOKEN',
    GET_PVS_CREDENTIALS: 'GET_PVS_CREDENTIALS',
    GET_PVS_PRIMARY: 'GET_PVS_PRIMARY',
  },
  actions: {
    AUTHORIZE: 'AUTHORIZE',
    COMPANY_CONFIGURATION: 'COMPANY_CONFIGURATION',
    SEND_PASSWORD_INSTRUCTIONS: 'SEND_PASSWORD_INSTRUCTIONS',
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    RESET_PASSWORD: 'RESET_PASSWORD',
    SEND_UNLOCK_INSTRUCTIONS: 'SEND_UNLOCK_INSTRUCTIONS',
    UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
    SET_COMPANY: 'SET_COMPANY',
    SETUP_PASSWORD: 'SETUP_PASSWORD',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    EXPIRES_IN: 'EXPIRES_IN',
    RE_FETCH_USER_INFO: 'RE_FETCH_USER_INFO',
    POST_COMMPIX_CREDENTIALS: 'POST_COMMPIX_CREDENTIALS',
    POST_MASSPAYMENT_CREDENTIALS: 'POST_MASSPAYMENT_CREDENTIALS',
    GET_COMMPIX_CREDENTIALS: 'GET_COMMPIX_CREDENTIALS',
    GET_MASSPAYMENT_CREDENTIALS: 'GET_MASSPAYMENT_CREDENTIALS',
    GET_MANTECA_CREDENTIALS: 'GET_MANTECA_CREDENTIALS',
    AUTH_COMMPIX: 'AUTH_COMMPIX',
    POST_PVS_CREDENTIALS: 'POST_PVS_CREDENTIALS',
    GET_PVS_CREDENTIALS: 'GET_PVS_CREDENTIALS',
  },
};
